module.exports = __webpack_public_path__ + "img/Weapon_134.4c5c876b.png";